(function($) {

	Flickity.prototype._createResizeClass = function() {
		this.element.classList.add('flickity-resize');
	};
	Flickity.createMethods.push('_createResizeClass');
	var resize = Flickity.prototype.resize;
	Flickity.prototype.resize = function() {
		this.element.classList.remove('flickity-resize');
		resize.call(this);
		this.element.classList.add('flickity-resize');
	};

	$(document).ready(function() {

		// homepage news ticker flickity ini
		if ( $( '.news-ticker' ).length > 0 ) {
			$('.main-carousel').flickity({
				cellAlign: 'left',
				contain: true,
				wrapAround: true,
				autoPlay: 5000,
				prevNextButtons: false,
			});
		}

		// testimonial slider init
		if (window.innerWidth >= 640) {
			$('.testimonials-carousel').flickity({
				// options
				adaptiveHeight: false,
				autoPlay: true,
				setGallerySize: true,
				wrapAround: true,
				cellAlign: 'center',
				pageDots: true,
				prevNextButtons: false,
				initialIndex: 1,
				arrowShape: 'M23.146,25.732L0.793,48.085c-1.058,1.058-1.058,2.773,0,3.831l22.353,22.353c1.706,1.706,4.624,0.498,4.624-1.915V56.32 h69.521c1.496,0,2.709-1.213,2.709-2.709v-7.223c0-1.496-1.213-2.709-2.709-2.709H27.77V27.647 C27.77,25.234,24.852,24.026,23.146,25.732L23.146,25.732z'
			});
		} else {
			$('.testimonials-carousel').flickity({
				// options
				adaptiveHeight: true,
				autoPlay: true,
				setGallerySize: true,
				wrapAround: true,
				cellAlign: 'center',
				pageDots: true,
				prevNextButtons: false,
				initialIndex: 0,
				arrowShape: 'M23.146,25.732L0.793,48.085c-1.058,1.058-1.058,2.773,0,3.831l22.353,22.353c1.706,1.706,4.624,0.498,4.624-1.915V56.32 h69.521c1.496,0,2.709-1.213,2.709-2.709v-7.223c0-1.496-1.213-2.709-2.709-2.709H27.77V27.647 C27.77,25.234,24.852,24.026,23.146,25.732L23.146,25.732z'
			});
		}

		// destroy carousel if featherlight box closed
		if (typeof $.featherlight !== 'undefined' && $.isFunction($.featherlight)) {
			$('body.page-template-page-portfolio a[href*="feather-"]').featherlight({
				targetAttr: 'href',
				beforeClose: function(event) {
					var $carousel = $('.featherlight-carousel').flickity();
					$carousel.flickity('destroy');
					return;
				}
			});
		}

		$('body.page-template-page-portfolio section.portfolio-gallery .card-wrapper').on('click', function() {

			setTimeout(function() {
				$('.featherlight-carousel').flickity({
					// options
					cellAlign: 'center',
					setGallerySize: false,
					contain: true,
					wrapAround: true,
					pageDots: false,
					autoPlay: 7000
				});
			}, 200);

		});

	}); // document.ready
})(jQuery);
